// computeeLtdTier() returns a 1-based tier (1 code→1, 2→2, 3-4→3, 5+→4), so the
// internal tier number already IS the AppSumo tier shown to users. Identity mapping.
// (NOTE: backend currently caps at internal tier 4 — there is no distinct "Tier 5".)
export const displayTier = (internalTier) =>
    internalTier == null ? null : internalTier;

export const displayTierLabel = (internalTier) => {
    const d = displayTier(internalTier);
    return d == null ? "" : `Tier ${d}`;
};

const PLAN_LABELS = { free: "Free", starter: "Starter", pro: "Pro", business: "Business", agency: "Agency", "legacy-premium": "Premium" };
export const planLabel = (slug) => PLAN_LABELS[slug] || (slug ? slug[0].toUpperCase() + slug.slice(1) : "");

// Canonical badge label for a user's plan. LTD tiers are mapped to a SaaS slug internally
// (e.g. Tier 2 → "pro") only so legacy readers have a value — but that slug OVERSTATES what
// the tier grants (LTD T2 has no Agent Actions, SaaS Pro does), so showing "Pro" to a Tier 2
// buyer is misleading and contradicts the feature gates. Always show the actual Lifetime tier
// for LTD users. Pass the /api/plan-state payload.
export const effectivePlanLabel = (planState) => {
    if (planState?.has_ltd) return `Lifetime ${displayTierLabel(planState.ltd_tier)}`;
    return planLabel(planState?.effective_plan);
};
